import { render } from "./MovieScrollerCard.vue?vue&type=template&id=5ac7198c"
import script from "./MovieScrollerCard.vue?vue&type=script&lang=js"
export * from "./MovieScrollerCard.vue?vue&type=script&lang=js"
script.render = render

export default script